import html2canvas from 'html2canvas';
// type 指定 为 canvas  或者 img
export const getCanvas = (element, opt) => {
    if (!element) return console.error("请传入截图元素");
    var options = Object.assign({ allowTaint: true,useCORS:true,removeContainer:true,imageTimeout:3000 }, opt)
    return new Promise((resolve, reject) => {
        html2canvas(element, options).then(function (canvas) {
            resolve({ image:canvas.toDataURL("image/png"), canvas: canvas })
            }).catch((error) => {
                // 错误处理
                console.error(error);
                reject(null)
            })
    })

};
